export default __webpack_public_path__ + "static/media/google-docs.840d8354.png";